import React from 'react';

// Context
import FiltersContext from '../../../context/FiltersContext';

// Hooks
import { useContext } from 'react';

// Components
import MultiSelector from '../../UI/MultiSelector/MultiSelector';

// interfaces 
interface Props {
    selectedProfileIDs: number[]
    handleSetProfileIDs: (ids: number[]) => void
}

const MultiSelectEnvironment: React.FC<Props> = ({ selectedProfileIDs, handleSetProfileIDs }) => {


    const { profilesZones } = useContext(FiltersContext)

    const handleChange = (id: number | string) => {
        const profileID = Number(id);
        if (profileID === -1) handleSetProfileIDs(profileOptions.every(o => o.checked) ? [] : profileOptions.map(p => p.id));
        else handleSetProfileIDs(selectedProfileIDs.includes(profileID) ? selectedProfileIDs.filter(pID => pID !== profileID) : [...selectedProfileIDs, profileID])
    }

    const profileOptions = [
        ...profilesZones.map(pz => ({ id: pz.profile.id, name: pz.profile.name, checked: selectedProfileIDs.includes(pz.profile.id) }))];


    return (
        <MultiSelector
            options={profileOptions}
            handleChange={handleChange}
            style={{ width: '400px' }}
        />
    );
};

export default MultiSelectEnvironment;